module.exports = __webpack_public_path__ + "img/color_gold_a-2230-1.9e91081.jpg";